<div class="mt-table-paginator">
    <!-- First page btn -->
    <img
        (click)="currentPage > 1 && changePage(1)"
        class="paginator-img"
        appImageSelector
        imageType="icon"
        [imageKey]="
            currentPage === 1
                ? 'table-pagination-disabled-first'
                : 'table-pagination-active-first'
        "
        [class.disabled]="currentPage === 1"
    />

    <!-- Prev page btn -->
    <img
        (click)="currentPage > 1 && changePreviousPage(currentPage)"
        class="paginator-img"
        appImageSelector
        imageType="icon"
        [imageKey]="
            currentPage === 1
                ? 'table-pagination-disabled-left'
                : 'table-pagination-active-left'
        "
        [class.disabled]="currentPage === 1"
    />

    <!-- Page input browser -->
    <input
        class="page-input"
        type="text"
        size="2"
        [value]="currentPage"
        (keydown)="validateInput($event)"
        (input)="adjustWidth($event)"
        (change)="changePage($event.target.value)"
    />
    {{ "of" | lang }} {{ maxPage || 1 }}

    <!-- Next page btn -->
    <img
        (click)="currentPage < maxPage && changeNextPage(currentPage)"
        class="paginator-img"
        appImageSelector
        imageType="icon"
        [imageKey]="
            currentPage === maxPage
                ? 'table-pagination-disabled-right'
                : 'table-pagination-active-right'
        "
        [class.disabled]="currentPage === maxPage"
    />

    <!-- Last page btn -->
    <img
        (click)="currentPage < maxPage && changePage(maxPage)"
        class="paginator-img"
        appImageSelector
        imageType="icon"
        [imageKey]="
            currentPage === maxPage
                ? 'table-pagination-disabled-last'
                : 'table-pagination-active-last'
        "
        [class.disabled]="currentPage === maxPage"
    />
</div>
